export enum MultiFunctionalButtonEvent {
    STATE_CHANGED = 'onMultiFunctionalButtonStateChanged'
}
